export const DEVELOP_HISTORY_ACTION_LIST = 'DEVELOP_HISTORY_ACTION_LIST';//开发环境下的历史记录动作列表
export const DEVELOP_CURRENT_THEME_KEY = 'DEVELOP_CURRENT_THEME_KEY';//开发环境下的主题颜色
export const DEVELOP_MARKET_MODULE_LIST = 'DEVELOP_MARKET_MODULE_LIST';//开发环境下的组件市场数据
export const DEVELOP_CUSTOM_MODULE_LIST = 'DEVELOP_CUSTOM_MODULE_LIST';//开发环境下的业务组件数据